import api from '@/api'
export default {
  // 获取不同状态的训练计划列表-GET-可分页-系统管理员/技术支持调用
  getTrainPlanListSystem (params) {
    return api({
      url: '/event/pageTrainListSystem',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-会员协会调用
  getTrainPlanListOrgan (params) {
    return api({
      url: '/event/pageTrainListOrgan',
      method: 'GET',
      params
    })
  },
  getTrainPlanListPlayer (params) {
    return api({
      url: '/event/pageTrainListPlayer',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-青训中心调用
  getTrainPlanListYouth (params) {
    return api({
      url: '/event/pageTrainListYouth',
      method: 'GET',
      params
    })
  },
  // 获取不同状态的训练计划列表-GET-可分页-教练/领队调用
  getTrainPlanListCoach (params) {
    return api({
      url: '/event/trainingPlanInfo/pageTrainListCoach',
      method: 'GET',
      params
    })
  },
  // 获取完成状态训练计划的详细信息
  getTrainDetail (trainingPlanUuid) {
    return api({
      url: '/event/trainingPlanInfo/infoTrainingPlanCompleteStatus',
      method: 'GET',
      params: { trainingPlanUuid }
    })
  },
  // 删除训练计划
  deleteEvent (params) {
    return api({
      url: '/event/deleteTrainSoft',
      method: 'DELETE',
      params
    })
  },
  // 删除训练计划
  XiuxiEvent (params) {
    return api({
      url: '/event/xiuxiTrainSoft',
      method: 'POST',
      params
    })
  },
  // 退回训练计划
  backEvent (params) {
    return api({
      url: '/event/backTrainSoft',
      method: 'POST',
      params
    })
  },
  // 第一步:编写训练计划-保存
  FirstTrain (data) {
    return api({
      url: '/event/train',
      method: 'POST',
      data
    })
  },
  // 第一步:编写训练计划-保存-文件创建用
  FirstTrainForDoc (data) {
    return api({
      url: '/event/trainFile',
      method: 'POST',
      data
    })
  },
  // 第一步:训练计划-回显
  trainInfo (uuid) {
    return api({
      url: `/event/trainInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 第一步:训练计划-回显-文件创建用
  trainInfoForDoc (uuid) {
    return api({
      url: `/event/trainFileInfo/${uuid}`,
      method: 'GET'
    })
  },
  // 第一步:训练计划-刪除-教案文件
  deleteTrainFile (uuid) {
    return api({
      url: `/event/trainFileRemove/${uuid}`,
      method: 'DELETE'
    })
  },



  // 第二步:确认实施-获取球员列表
  getPlayerList (params) {
    return api({
      url: '/event/playerList',
      method: 'GET',
      params
    })
  },
  // 第二步:确认实施-保存球员分组
  savePlayerGroup (data, trainingUuid) {
    return api({
      url: '/event/savePlayerGroup',
      method: 'POST',
      data,
      params: { training_uuid: trainingUuid }
    })
  },
  // 第三步:训练评价-获取训练评价详情
  commentInfo (eventUuid) {
    return api({
      url: '/event/commentInfo',
      method: 'GET',
      params: { event_uuid: eventUuid }
    })
  },
  // 第三步:训练评价-保存球员出勤
  savePlan (data) {
    return api({
      url: '/event/savePlayerAttendance',
      method: 'POST',
      data
    })
  },
  downloadPlan (params) {
    return api({
      url: '/event/trainingPlanInfo/trainingPlanDownLoadPdf',
      method: 'GET',
      params
    })
  },

}
